import VueCookies from 'vue-cookies'

const USER_INFO_COOKIE_AGE = '12h'

export const user = {
  namespaced: true,
  state() {
    return {
      userInfo: VueCookies.get('userInfo') || {} // 로그인 정보를 어떻게 저장할지가 관건이다. 정보를 넣기 위해서는 mutation setUser를 사용해야 한다.
    }
  },
  getters: {
    isLogin(state) {
      // state.userInfo를 참조해야 Vuex가 반응성을 추적하여 getter를 재평가함
      if (state.userInfo && state.userInfo.email) {
        return true
      }
      // 새로고침 시 쿠키에서 복원
      if (VueCookies.get('userInfo')) {
        return true
      }
      return false
    }
  },
  mutations: {
    // 방법1. vue-cookies 설치 ; 시간설정 할수 있음.
    // 방법2. vuex-persistedstate 설치: 로컬스토리지에 저장됨.
    setUser(state, userInfo) {
      // userInfo는 로그인 후 받아온 정보이다.
      state.userInfo = userInfo
      // 새로고침해도 사용자 정보를 유지하기 위해 쿠키에 저장한다. ===================
      VueCookies.set('userInfo', userInfo, USER_INFO_COOKIE_AGE)
    },
    logout(state) {
      state.userInfo = {} // vuex-persistedstate를 사용할때
      VueCookies.remove('userInfo') // vue-cookies를 사용할때
      window.localStorage.removeItem('vuex')
    }
  },
  actions: {
    // 비동기
    // 서버에 저장함.
  }
}
